import { chinaGovIdDuplicateCheck } from 'components/common/form/formValidationRules';
import { chinaIdValidation } from 'api/validation';
import { match } from 'components/common/form/formValidationRules';
import { fiftyCharactersMax, numericRegex } from 'helpers/regex';

const CN = {
  serviceObjects: {
    autoComplete: false,
  },
  market: 'CN',
  enrollment: {
    form: {
      sections: {
        account: {
          fields: ['NAME_FIRST', 'NAME_LAST', 'COMPANY', 'EMAIL', 'PASSWORD'],
        },
        shipping: {
          fields: ['STATE', 'CITY', 'COUNTY', 'ADDRESS1', 'ADDRESS2'],
        },
        idVerification: {
          fields: ['GOVERNMENT_NAME', 'GOVERNMENT_ID'],
          order: 5,
          onBlur: chinaIdValidation,
          market: 'HK',
        },
      },
    },
  },
  inputs: {
    GOVERNMENT_ID: {
      mask: '99999999999999999*',
      validationChecks: [match(/^.{18}$/, 'validation-18-characters')],
    },
    ADDRESS2: {
      validationChecks: [match(fiftyCharactersMax, 'validation-max-50')],
    },
    PHONE: {
      type: 'tel',
      labelRef: 'SHIPPING_PHONE',
      mask: '99999999999',
      validationChecks: [
        match(/^\d*$/, 'validation-numbers-only'),
        match(/^\d{11}$/, 'validation-11characters'),
      ],
    },
    STATE: {
      type: 'dropdown',
      labelRef: 'PROVINCE',
    },
    CITY: {
      dataLink: 'STATE',
      type: 'dropdown',
    },
    COUNTY: {
      dataLink: ['CITY', 'STATE'],
      labelRef: 'DISTRICT',
      hide: false,
      type: 'dropdown',
    },
  },
};
export default CN;
